import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class LoyaltyEarningRules {
  constructor() {
    this.$el = document.querySelector(".js-loyalty-earning-rules");

    if (!this.$el) {
      return;
    }

    this.$background = this.$el.querySelector(".js-loyalty-earning-rules-bg");
    this.$title = this.$el.querySelector(".js-loyalty-earning-rules-title");
    this.$description = this.$el.querySelector(
      ".js-loyalty-earning-rules-description"
    );
    this.$stage = this.$el.querySelector(".js-loyalty-earning-rules-stage");
    this.$placeholderItems = this.$el.querySelectorAll(
      ".js-loyalty-earning-rules-placeholder-item"
    );
    this.$items = this.$el.querySelectorAll(".js-loyalty-earning-rules-item");
    this.$itemsToAnimate = this.$el.querySelectorAll(
      ".js-loyalty-earning-rules-item:not(.-no-animate)"
    );
    this.$itemsNoAnimate = this.$el.querySelectorAll(
      ".js-loyalty-earning-rules-item.-no-animate"
    );
    this.boxWidth = this.$el.querySelector(
      ".js-loyalty-earning-rules-box"
    ).offsetWidth;

    this.animate();
  }

  animate() {
    const introTimeline = gsap.timeline({
      scrollTrigger: {
        trigger: this.$el,
        scrub: true,
        end:
          window.innerWidth > 1024 && window.innerHeight > 1000
            ? "+=3000"
            : "bottom 50%",
        pin: window.innerWidth > 1024 && window.innerHeight > 1000,
        anticipatePin: 1,
      },
    });

    // Jumble the items
    this.$itemsToAnimate.forEach(($item, index) => {
      this.radomiseItem($item, index);
    });

    this.$itemsNoAnimate.forEach(($item, index) => {
      gsap.set($item, {
        opacity: Math.random() * (1 - 0.2) + 0.2,
      });
    });

    introTimeline
      // .fromTo(
      //   this.$background,
      //   {
      //     opacity: 0,
      //     scale: 0,
      //   },
      //   {
      //     scale: window.innerWidth < 1024 ? 1.5 : 1,
      //     opacity: 1,
      //     duration: 2,
      //     ease: "expo.out",
      //   }
      // )
      // .fromTo(
      //   this.$title,
      //   {
      //     opacity: 0.5,
      //   },
      //   {
      //     opacity: 1,
      //     duration: 4,
      //     ease: "expo.out",
      //   },
      //   "-=1.5"
      // )
      // .fromTo(
      //   this.$description,
      //   {
      //     opacity: 0.5,
      //   },
      //   {
      //     opacity: 1,
      //     duration: 4,
      //     ease: "expo.out",
      //   },
      //   "-=3.5"
      // )
      .fromTo(
        this.$stage,
        {
          scale: 0.75,
          opacity: 0.5,
        },
        {
          scale: 1,
          opacity: 1,
          duration: 4,
          ease: "expo.out",
        },
        "-=3.5"
      )
      .fromTo(
        this.$placeholderItems,
        {
          opacity: 0.5,
          scale: 0,
        },
        {
          opacity: 1,
          scale: 1,
          duration: 2,
          ease: "expo.out",
        },
        "-=3.5"
      )
      .to(
        this.$itemsToAnimate,
        {
          opacity: 1,
          duration: 0.5,
          ease: "expo.out",
        },
        "-=4"
      )
      .to(
        this.shuffle(this.$itemsToAnimate),
        {
          x: 0,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          duration: 2,
          ease: "expo.out",
        },
        "-=3"
      )
      .to(
        this.$itemsNoAnimate,
        {
          opacity: 1,
          duration: 2,
          ease: "expo.out",
        },
        "-=3"
      )
      .to(
        this.$placeholderItems,
        {
          opacity: 0,
          duration: 2,
          ease: "expo.out",
        },
        "-=2"
      );
  }

  radomiseItem($item, index, isExtras = false) {
    if (index % 2 === 0) {
      gsap.set($item, {
        x: `-${Math.random() * (this.boxWidth / 2) + this.boxWidth / 2}px`,
        y: `${Math.random() * 40 - 20}px`,
        opacity: Math.random() * (1 - 0.2) + 0.2,
      });
    } else {
      gsap.set($item, {
        x: `${Math.random() * (this.boxWidth / 2) + this.boxWidth / 2}px`,
        y: `${Math.random() * 40 - 20}px`,
        opacity: Math.random() * (1 - 0.2) + 0.2,
      });
    }
  }

  shuffle(nodeList) {
    // Convert NodeList to an array
    const array = Array.from(nodeList);

    // Shuffle the array using the Fisher-Yates algorithm
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }

    return array;
  }
}
